import type { Originator, RTCSession } from '@per_moeller/jssip-telecomx/lib/RTCSession'
import JsSIP from '@per_moeller/jssip-telecomx'

export interface SipClientRTCSession extends RTCSession {
	data: {
		callId?: string
		audioElement?: HTMLAudioElement
		direction?: 'INBOUND' | 'OUTBOUND'
		originator?: Originator
		tcxState?: SipClientTcxState
		caller?: {
			number: string
			name: string
		}
		callee?: {
			number: string
			name: string
		}
		endCause?: string
		localMediaStream?: MediaStream
		/** When the call was answered (Date.now()) - no re-INVITE goes out until it has settled, see RenegotiationQueue */
		answeredAt?: number
	}
}

export interface SipClientUA extends JsSIP.UA {
	tcxTag?: string
	tcxCreated?: Date
}

/** SIP client events */
export enum SipClientEvent {
	CONNECTING = 'CONNECTING',
	CONNECTED = 'CONNECTED',
	DISCONNECTED = 'DISCONNECTED',
	REGISTERED = 'REGISTERED',
	UNREGISTERED = 'UNREGISTERED',
	REGISTERFAILED = 'REGISTERFAILED',
	INBOUND = 'INBOUND',
	ANSWERED = 'ANSWERED',
	HOLD = 'HOLD',
	UNHOLD = 'UNHOLD',
	MUTED = 'MUTED',
	END = 'END',
	OUTBOUND = 'OUTBOUND'
}

/** Reasons for a call to end */
export enum SipClientEndReason {
	BUSY = 'BUSY',
	REJECTED = 'REJECTED',
	REDIRECTED = 'REDIRECTED',
	UNREACHABLE = 'UNREACHABLE',
	NOT_FOUND = 'NOT_FOUND',
	BYE = 'BYE',
	CANCELLED = 'CANCELLED',
	NO_ANSWER = 'NO_ANSWER',
	ERROR = 'ERROR'
}

/** Call states as they are used in Realtime events */
export enum SipClientTcxState {
	/** Call is starting */
	CALL_START = 'CALL_START',
	/** Call is ringing */
	CALL_RING = 'CALL_RING',
	/** Call is answered */
	CALL_ANSWER = 'CALL_ANSWER',
	/** Call is being held / is on hold */
	CALL_HOLD = 'CALL_HOLD',
	/** Call is being unheld */
	CALL_UNHOLD = 'CALL_UNHOLD',
	/** Call has ended */
	CALL_END = 'CALL_END',
	/** Call details updated */
	CALL_UPDATE = 'CALL_UPDATE'
}
